










import { Vue, Component } from "av-ts";

import OverviewDescription from "../util/OverviewDescription.vue";
import Notifications from "../util/Notifications.vue";

@Component({
    components:{
        OverviewDescription,
        Notifications
    }
})
export default class NotificationsView extends Vue {

}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/profile/Notifications.vue